export default __webpack_public_path__ + "static/media/BRL.e3676ee2.svg";